import agendaApiConfig from "./agendaApiConfig";

const TipoExamenService = {
    async getAll (sue_correl = null) {
        //return await agendaApiConfig.get("/imagenologia/tipo_examen");
        let query =  {};
        if(process.env.REACT_APP_SERVICIO_IMG == ""){
            query = null;
        }else{
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO_IMG, sue_correl}; 
        }
        return await agendaApiConfig.get("/imagenologia/tipo_examen", {
            params: {
                ...query
            }
        });
    },
    async getExamenes(codeExamen = 0) {
        //return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`);
        let query =  {};
        if(process.env.REACT_APP_SERVICIO_IMG == ""){
            query = null;
        }else{
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO_IMG }; 
        }
        return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`, {
            params: {
                ...query
            }
        });
    }
}

export default TipoExamenService;